<div class="grease-fluid-request-form">
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="greaseDateTime">Date/Time</label>
                <wj-input-date-time
                    [(ngModel)]="greaseFluidRequest().dateTime"
                    name="greaseDateTime"
                    id="greaseDateTime"
                    [isRequired]="false"
                ></wj-input-date-time>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="greaseJob">Job</label>
                <wj-combo-box
                    [(ngModel)]="greaseFluidRequest().job"
                    name="greaseJob"
                    id="greaseJob"
                    [itemsSource]="jobOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="greaseOperatorName">Operator Name</label>
                <wj-combo-box
                    [(ngModel)]="greaseFluidRequest().operatorName"
                    name="greaseOperatorName"
                    id="greaseOperatorName"
                    [itemsSource]="employeeOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="greaseEquipmentNumber">Equipment #</label>
                <wj-combo-box
                    [(ngModel)]="greaseFluidRequest().equipmentNumber"
                    name="greaseEquipmentNumber"
                    id="greaseEquipmentNumber"
                    [itemsSource]="equipmentOptions()"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                ></wj-combo-box>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-12">
            <div class="form-group">
                <label for="greaseHoursMileage">Hour Meter / Odometer Reading</label>
                <input type="text" class="form-control" [(ngModel)]="greaseFluidRequest().hoursMileage" name="greaseHoursMileage" id="greaseHoursMileage" />
            </div>
        </div>
    </div>

    <div class="fluid-section">
        <h6 class="fluid-section-heading">Fluid Request &amp; Service Needs</h6>
        @for (fluid of greaseFluidRequest().fluids; track fluid.label; let i = $index) {
            <div class="fluid-row">
                <span class="fluid-label">{{ fluid.label }}</span>
                <div class="fluid-checks">
                    <label class="fluid-check">
                        <input type="checkbox" [(ngModel)]="fluid.lowOrNeeded" [name]="'fluidLow_' + i" />
                        Low / Needs Fluid
                    </label>
                    <label class="fluid-check">
                        <input type="checkbox" [(ngModel)]="fluid.leakDetected" [name]="'fluidLeak_' + i" />
                        Leak Detected
                    </label>
                </div>
            </div>
        }

        <div class="fluid-row">
            <span class="fluid-label">Grease / Lubrication</span>
            <div class="fluid-checks">
                <label class="fluid-check">
                    <input type="checkbox" [(ngModel)]="greaseFluidRequest().greaseRoutineLubrication" name="greaseRoutine" />
                    Routine Lubrication
                </label>
                <label class="fluid-check">
                    <input type="checkbox" [(ngModel)]="greaseFluidRequest().greaseDryOrNoisy" name="greaseDryNoisy" />
                    Dry / Noisy Components
                </label>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="greaseOtherFluid">Other Fluid (specify)</label>
                <input type="text" class="form-control" [(ngModel)]="greaseFluidRequest().otherFluid" name="greaseOtherFluid" id="greaseOtherFluid" placeholder="e.g. DEF, brake fluid..." />
            </div>
        </div>
    </div>

    <div class="fluid-section">
        <h6 class="fluid-section-heading">General Equipment Condition</h6>
        @for (check of greaseFluidRequest().conditionChecks; track check.label; let i = $index) {
            <label class="condition-check">
                <input type="checkbox" [(ngModel)]="check.checked" [name]="'condition_' + i" />
                {{ check.label }}
            </label>
        }
    </div>

    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label for="greaseAdditionalNotes">Additional Notes</label>
                <textarea
                    rows="3"
                    class="form-control"
                    [(ngModel)]="greaseFluidRequest().additionalNotes"
                    name="greaseAdditionalNotes"
                    id="greaseAdditionalNotes"
                    placeholder="Enter any additional notes..."
                ></textarea>
            </div>
        </div>
    </div>
</div>
